import { ValorCartaCreditoFinanceiro } from './valor-carta-credito.model'

export class ValorCartaCreditoTrimestralVO {

  investimentoPDI: ValorCartaCreditoFinanceiro;
  faturamentoTotalProduto: ValorCartaCreditoFinanceiro
  valorCredito: ValorCartaCreditoFinanceiro;
  limiteCredito: ValorCartaCreditoFinanceiro;
  valorPDIExcedente: ValorCartaCreditoFinanceiro


}
